import { render } from "./ImportModelButton.vue?vue&type=template&id=ad79066e"
import script from "./ImportModelButton.vue?vue&type=script&lang=js"
export * from "./ImportModelButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__